import React, { useState } from 'react';
import useStyles from './styles';
import { useTheme } from '@mui/material/styles';
import { icons } from '../../utils/icons';
import moment from 'moment';
import { Strings } from '../../utils/strings';
import { statusColor } from '../../utils/appUtils';

const JobsContainer = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  // const [openIssues, setOpenIssues] = useState([]);

  // const handleOpenIssues = (index) => {
  //   if (openIssues.findIndex((item, i) => item === index) === -1) {
  //     setOpenIssues([...openIssues, index]);
  //   } else {
  //     setOpenIssues(openIssues.filter((item) => item !== index));
  //   }
  // };
  return (
    <>
      {props.data?.length === 0 ? (
        <div className={classes.flexView}>
          <p className={classes.no_data_message}>{Strings.NO_DATA_FOUND}</p>
        </div>
      ) : (
        props.data?.map((item, index) => (
          <div className={classes.container}>
            <div className={classes.issues_header}>
              {/* <img
              className={classes.toggle_arrow}
              src={
                openIssues.findIndex((item) => item === index) !== -1
                  ? icons(theme).downArrow
                  : icons(theme).rightArrow
              }
              alt=''
              onClick={() => handleOpenIssues(index)}
            /> */}
              <label htmlFor='date' className={classes.issues_title}>
                {item?.title}
              </label>
              <label htmlFor='Issues' className={classes.date_label}>
                {item.endDate && moment(item.endDate).format('DD MMM, YYYY')}
              </label>
            </div>
            <div className={classes.issues_footer}>
              <div className={classes.issue_status} style={{ backgroundColor: statusColor(item.jobStatus)}} >{item.jobStatus}</div>
            </div>
          </div>
        ))
      )}
    </>
  );
};
export default JobsContainer;
